<div class="create-shell mt-5">
  <section class="create-acfs">
    <div class="acfs-copy">
      <h1>รับซื้อ / รับสินค้า</h1>
      <p>บันทึกการรับซื้อสินค้าหรือรับสินค้าเข้าสต็อก</p>
    </div>
    <img class="acfs-new-img" src="/assets/images/empty-basket.png" alt="">
  </section>

  @if (loading()) {
    <section class="product-list-card product-list-skeleton" aria-busy="true" aria-label="กำลังโหลด">
      <div class="skeleton-label"></div>
      @for (item of [1, 2, 3]; track item) {
        <article class="product-skeleton-row">
          <div class="product-skeleton-head">
            <div class="skeleton-copy">
              <div class="skeleton-line skeleton-title"></div>
              <div class="skeleton-line skeleton-sub"></div>
            </div>
            <div class="skeleton-badge"></div>
            <div class="skeleton-icon"></div>
          </div>
        </article>
      }
    </section>
    <div class="text-center text-secondary small py-2">กำลังค้นหาใบขาย…</div>
  } @else if (lotRecord(); as lot) {
    @if (lotOffers().length > 1) {
      <section class="detail-card mb-3" aria-label="ใบขายของผู้ขาย">
        <div class="form-section">
          <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
            <span class="badge text-bg-light border">{{ lot.productName || '-' }}</span>
            <span class="fw-semibold">{{ lot.businessTitle || '-' }}</span>
            <span class="text-secondary small">มีใบขายเปิดอยู่ {{ lotOffers().length }} ใบ เลือกใบที่ผู้ขายแจ้งคุณ</span>
          </div>
          <div class="list-group lot-offer-list">
            @for (item of lotOffers(); track item.id) {
              <button type="button" class="list-group-item list-group-item-action lot-offer" (click)="useOffer(item)">
                <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
                  <span>
                    <span class="badge text-bg-warning me-1">ใบขาย</span>
                    {{ (item.items ?? [])[0]?.productName || '-' }}
                    <span class="fw-semibold">{{ formatQuantityWithUnit(item.totalQuantity, unit) }}</span>
                  </span>
                  <span class="text-secondary small">{{ item.createdAt | thaidatetime }}</span>
                </div>
              </button>
            }
          </div>
        </div>
      </section>
    } @else {
      <section class="state-band">
        <div class="empty-state">
          <div class="d-flex flex-column align-items-center text-center">
            <i class="bi bi-info-circle text-primary fs-3 mb-2" aria-hidden="true"></i>
            <span class="mb-3">
              {{ lot.businessTitle || 'ผู้ขาย' }} ยังไม่ได้สร้างใบขายสำหรับ {{ lot.productName || 'สินค้านี้' }}
              — แจ้งผู้ขายให้กด "ขาย" ที่สต็อกเพื่อสร้างใบขาย แล้วสแกนรหัสนี้อีกครั้งหรือสแกน QR ใบขาย
            </span>
            <div class="d-flex flex-wrap justify-content-center align-items-center gap-2">
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="retry()">ลองอีกครั้ง</button>
              @if (lot.owned && lot.id != null) {
                <a class="fw-semibold" [routerLink]="[tradeBase, lot.id]">ดูรายการนี้</a>
              }
              <a class="fw-semibold" routerLink="/trade">กลับไปรายการซื้อ-ขาย</a>
            </div>
          </div>
        </div>
      </section>
    }
  } @else if (notFound()) {
    <section class="state-band">
      <div class="empty-state">
        <i class="bi bi-exclamation-triangle text-warning fs-3 mb-2 d-block" aria-hidden="true"></i>
        <strong>ไม่พบใบขายจากรหัสนี้</strong>
        <p><a class="fw-semibold" routerLink="/trade">กลับไปรายการซื้อ-ขาย</a></p>
      </div>
    </section>
  } @else if (offer(); as current) {
    <section class="detail-card mb-3">
      <div class="business-summary" aria-label="ใบขายของผู้ขาย">
        <i class="bi bi-receipt" aria-hidden="true"></i>
        <div>
          <div class="d-flex align-items-center gap-2">
            <span class="badge text-bg-warning">ใบขายของผู้ขาย</span>
            <div class="business-summary-title">{{ current.businessTitle || '-' }}</div>
          </div>
          <div class="business-summary-meta">
            @if (viaLot(); as lot) {
              <span class="text-secondary small">ใบขายที่เปิดอยู่ของ {{ lot.productName || 'สินค้านี้' }} จาก QR รายการที่สแกน</span>
            } @else {
              <span class="text-secondary small">คุณกำลังรับสินค้าตามใบขายนี้เข้าสต็อกของคุณ — ผู้ขายเป็นผู้กำหนดรายการและจำนวน</span>
            }
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="table-responsive">
          <table class="table table-sm align-middle mb-2">
            <thead>
            <tr>
              <th scope="col">สินค้า</th>
              <th scope="col" class="text-end">จำนวน ({{ unit }})</th>
            </tr>
            </thead>
            <tbody>
              @for (item of items(); track item.id) {
                <tr class="offer-item-row">
                  <td>
                    <div>{{ item.productName || '-' }}</div>
                    @if (offerComponentsBreakdown(item.components); as breakdown) {
                      <div class="text-secondary small">{{ breakdown }}</div>
                    }
                  </td>
                  <td class="text-end">{{ formatQuantityWithUnit(item.quantity, '') }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <dl class="row mb-0 small">
          <dt class="col-5 col-sm-4 text-secondary fw-normal">รวมทั้งใบขาย</dt>
          <dd class="col-7 col-sm-8 mb-1 fw-semibold" id="receive-offer-quantity">
            {{ formatQuantityWithUnit(offerTotalQuantity(), unit) }}
          </dd>
          <dt class="col-5 col-sm-4 text-secondary fw-normal">วันที่สร้างใบขาย</dt>
          <dd class="col-7 col-sm-8 mb-1">{{ current.createdAt | thaidatetime }}</dd>
          @if (current.note) {
            <dt class="col-5 col-sm-4 text-secondary fw-normal">หมายเหตุ</dt>
            <dd class="col-7 col-sm-8 mb-0">{{ current.note }}</dd>
          }
        </dl>
        <small class="field-hint d-block mt-2">
          รับได้ไม่เกินจำนวนที่ผู้ขายระบุ ส่วนที่ไม่ได้รับจะคืนเข้าสต็อกของผู้ขาย
        </small>
      </div>
    </section>

    @if (store.businessesLoaded() && store.businesses().length === 0) {
      <section class="state-band">
        <div class="empty-state">
          <strong>ยังไม่มีธุรกิจสำหรับรับซื้อ</strong>
          <p>
            <button type="button" class="btn btn-link fw-semibold p-0 align-baseline" (click)="addBusiness()">เพิ่มข้อมูลธุรกิจ</button>
          </p>
        </div>
      </section>
    } @else {
      <section class="detail-card">
        <div class="form-section">
          <app-trade-business-select
            [businesses]="store.businesses()"
            [selectedId]="store.selectedBusinessId()"
            label="บันทึกในนามธุรกิจ"
            inputId="trade-receive-business"
            (selectedIdChange)="onBusinessChange($event)">
          </app-trade-business-select>

          @if (sameBusiness()) {
            <div class="alert alert-warning py-2 mt-2" role="alert">
              ไม่สามารถรับซื้อจากธุรกิจของตนเองได้
            </div>
          }

          <small class="field-hint d-block mt-2">
            @if (isExporterBusiness()) {
              บันทึกเป็นการรับซื้อสินค้าเพื่อส่งออก — รายการนี้เป็นปลายทางสุดท้ายของห่วงโซ่
            } @else {
              บันทึกเป็นการรับซื้อสินค้า
            }
          </small>
        </div>

        <div class="form-section">
          <div class="section-label">จำนวนที่รับและชื่อสินค้าในสต็อกของคุณ</div>
          @for (item of items(); track item.id; let lineIndex = $index) {
            <div class="harvest-box">
              <label class="harvest-input" [attr.for]="'receive-product-name-' + lineIndex">
                <span>{{ item.productName }}</span>
                <input [id]="'receive-product-name-' + lineIndex" type="text" class="form-control"
                       list="receive-stock-products" [ngModel]="productNameAt(lineIndex)"
                       (ngModelChange)="onProductNameChange(lineIndex, $event)"
                       [name]="'productName' + lineIndex">
              </label>

              <div class="quantity-unit-row">
                <label class="harvest-input" [attr.for]="'receive-qty-' + lineIndex">
                  <span>จำนวนที่รับจริง</span>
                  <input [id]="'receive-qty-' + lineIndex" type="number" class="form-control"
                         inputmode="decimal" min="0.01" step="0.01" [attr.max]="item.quantity"
                         [ngModel]="quantityAt(lineIndex)" [name]="'quantity' + lineIndex"
                         (ngModelChange)="onQuantityChange(lineIndex, $event)"
                         [class.is-invalid]="!!quantityError(lineIndex)">
                </label>
                <label class="harvest-input">
                  <span>หน่วย</span>
                  <input type="text" class="form-control unit-readonly" [value]="unit" readonly tabindex="-1">
                </label>
              </div>

              @if (quantityError(lineIndex); as error) {
                <small class="invalid-feedback d-block text-danger">{{ error }}</small>
              } @else {
                <small class="field-hint">จากใบขาย {{ formatQuantity(item.quantity) }} กก.</small>
              }
            </div>
          }
          <datalist id="receive-stock-products">
            @for (name of stockProductNames(); track name) {
              <option [value]="name"></option>
            }
          </datalist>
          <div class="pool-actions">
            <span class="text-secondary small" id="receive-total-quantity">
              รวมที่รับ {{ formatQuantityWithUnit(totalQuantity(), unit) }}
            </span>
            @if (partialReceive()) {
              <span class="text-secondary small" id="receive-partial-note">
                รับไม่ครบ ส่วนที่เหลือจะคืนเข้าสต็อกของผู้ขาย
              </span>
            }
          </div>
          <small class="field-hint d-block mt-2">
            ถ้าเป็นสินค้าชนิดเดียวกับที่มีอยู่แล้ว ให้ใช้ชื่อเดียวกันเพื่อรวมสต็อก
          </small>
        </div>

        <div class="form-section">
          @if (!exporterOnlyBusiness()) {
            <div class="harvest-box">
              <label class="harvest-input" for="receive-truck">
                <span class="ui-require">ทะเบียนรถ</span>
                <input id="receive-truck" type="text" class="form-control"
                       [(ngModel)]="form.truckNo" name="truckNo"
                       [class.is-invalid]="submitted() && truckMissing()">
              </label>
              <div class="driver-side-row">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="receive-truck-buyer" name="truckSide"
                         value="BUYER" [(ngModel)]="form.truckSide">
                  <label class="form-check-label" for="receive-truck-buyer">รถของผู้ซื้อ</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="receive-truck-seller" name="truckSide"
                         value="SELLER" [(ngModel)]="form.truckSide">
                  <label class="form-check-label" for="receive-truck-seller">รถของผู้ขาย</label>
                </div>
              </div>
              @if (submitted() && truckMissing()) {
                <small class="invalid-feedback d-block text-danger">กรุณากรอกทะเบียนรถ</small>
              }
              @if (submitted() && !truckMissing() && truckSideMissing()) {
                <small class="invalid-feedback d-block text-danger">กรุณาระบุว่าเป็นรถของผู้ซื้อหรือผู้ขาย</small>
              }
            </div>
          }
          <div class="harvest-box">
            <label class="harvest-input" for="receive-phone">
              <span>เบอร์โทรคนขับ</span>
              <input id="receive-phone" type="tel" class="form-control"
                     [(ngModel)]="form.contactPhone" name="contactPhone">
            </label>
          </div>
        </div>

        @if (isExporterBusiness()) {
          <div class="form-section">
            <div class="section-label">ข้อมูลส่งออก</div>
            <div class="harvest-box">
              <label class="harvest-input" for="receive-checkpoint">
                <span class="ui-require">ด่านที่ส่งออก</span>
                <select id="receive-checkpoint" class="form-select"
                        [(ngModel)]="form.exportCheckpointId" name="exportCheckpointId"
                        [class.is-invalid]="submitted() && checkpointMissing()">
                  <option value="">เลือกด่าน</option>
                  @for (checkpoint of checkpoints(); track checkpoint.id) {
                    <option [value]="checkpoint.id">{{ checkpoint.name }}</option>
                  }
                </select>
              </label>
              @if (submitted() && checkpointMissing()) {
                <small class="invalid-feedback d-block text-danger">กรุณาเลือกด่านที่ส่งออก</small>
              }
            </div>
            <div class="harvest-box">
              <label class="harvest-input" for="receive-exporter-reg">
                <span class="ui-require">ทะเบียนผู้ส่งออก</span>
                <input id="receive-exporter-reg" type="text" class="form-control"
                       [(ngModel)]="form.exporterRegistrationNo" name="exporterRegistrationNo"
                       [class.is-invalid]="submitted() && exporterRegistrationMissing()">
              </label>
              @if (submitted() && exporterRegistrationMissing()) {
                <small class="invalid-feedback d-block text-danger">กรุณากรอกทะเบียนผู้ส่งออก</small>
              }
            </div>
            <div class="harvest-box">
              <div class="form-check">
                <input id="receive-seller-location" type="checkbox" class="form-check-input"
                       [(ngModel)]="form.useSellerLocation" name="useSellerLocation">
                <label class="form-check-label" for="receive-seller-location">ใช้พิกัดภูมิศาสตร์ของผู้ขาย</label>
              </div>
              <small class="field-hint">รายการนี้จะปักหมุดบนแผนที่ที่ตำแหน่งของผู้ขาย แทนตำแหน่งธุรกิจของคุณ</small>
            </div>
            @if (!exporterOnlyBusiness()) {
              <div class="harvest-box">
                <div class="quantity-unit-row">
                  <label class="harvest-input" for="receive-container">
                    <span>เลขตู้</span>
                    <input id="receive-container" type="text" class="form-control"
                           [(ngModel)]="form.containerNo" name="containerNo">
                  </label>
                  <label class="harvest-input" for="receive-seal">
                    <span>ซีล</span>
                    <input id="receive-seal" type="text" class="form-control" [(ngModel)]="form.sealNo" name="sealNo">
                  </label>
                </div>
              </div>
              <div class="harvest-box">
                <label class="harvest-input" for="receive-quality">
                  <span>หมายเหตุคุณภาพ</span>
                  <textarea id="receive-quality" class="form-control" rows="2"
                            [(ngModel)]="form.qualityNote" name="qualityNote"></textarea>
                </label>
              </div>
            }
          </div>
        }

        <div class="submit-row submit-actions">
          <button type="button" class="btn btn-primary flex-grow-1" [disabled]="saving()" (click)="submit()">
            @if (saving()) {
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            }
            รับซื้อสินค้า
          </button>
          <a class="btn btn-outline-secondary" routerLink="/trade">ยกเลิก</a>
        </div>
      </section>
    }
  }
</div>
